import React from "react";
import ToolTip from "storybookComponents/Tooltip2";
import Icon from "storybookComponents/Icon";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./style.js";
import { IconDownArrowSM, IconLeftArrowLG } from "icons";

const ViewNavigation = ({
  classes,
  onTodayClick,
  onClickMonth,
  monthContent,
  onClickYear,
  yearContent,
  onClickPrev,
  onClickSwitch,
  onClickNext,
  switchContent,
  switchColSpan,
  switchProps,
}) => {
  return (
    <tr>
      <th colSpan={7}>
        <div className={classes.topContainer}>
          <div className={classes.leftContainer}>
            {monthContent ? (
              <div className={classes.monthView} onClick={onClickMonth}>
                <span className={classes.leftMargin}>{monthContent}</span> <IconDownArrowSM />
              </div>
            ) : null}
            {yearContent ? (
              <div className={classes.yearView} onClick={onClickYear}>
                <span className={classes.leftMargin}> {yearContent} </span>
                <IconDownArrowSM />
              </div>
            ) : null}
          </div>
          <div className={classes.rightContainer}>
            {yearContent ? (
              <div className="rdtPrev" onClick={onClickPrev}>
                <ToolTip
                  text={monthContent ? "Previous month" : "Previous decade"}
                  position="bottom"
                >
                  <div>
                    <IconLeftArrowLG />
                  </div>
                </ToolTip>
              </div>
            ) : null}
            <div className={`rdtPrev ${classes.alignMent}`} onClick={onTodayClick}>
              <ToolTip text="Today" position="bottom">
                <div className={classes.dimondIcon}></div>
              </ToolTip>
            </div>
            {yearContent ? (
              <div className="rdtNext" onClick={onClickNext}>
                <ToolTip text={monthContent ? "Next month" : "Next decade"} position="bottom">
                  <div className={classes.iconRotate}>
                    <IconLeftArrowLG />
                  </div>
                </ToolTip>
              </div>
            ) : null}
          </div>
        </div>
      </th>
    </tr>
  );
};

export default withStyles(styles)(ViewNavigation);
